import React, { Fragment } from 'react'
import { useContent, ContentProps } from './useContent'
import blockContentToHtml from '@sanity/block-content-to-html'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Content.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const Content: React.FC<ContentProps> = (props: ContentProps) => {
  const { isAr, departmentDetails, t } = useContent(props)

  return departmentDetails && departmentDetails.length ? (
    <article id='department-content' className={styles['department-content']}>
      <section
        id='department-definition'
        className={styles['department-definition']}
      >
        <FontAwesomeIcon icon='book-open' className={styles['bg-icon']} />
        <TitleSection title={t('definition')} />
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <AnimatedContainer
                animation='bounceInDown'
                extraCssClasses='h-100'
              >
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: isAr
                      ? Array.isArray(departmentDetails[0].definitionAr)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].definitionAr,
                          })
                        : `<p>${departmentDetails[0].definitionAr}</p>`
                      : Array.isArray(departmentDetails[0].definitionEn)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].definitionEn,
                          })
                        : `<p>${departmentDetails[0].definitionEn}</p>`,
                  }}
                ></div>
              </AnimatedContainer>
            </div>
          </div>
        </div>
      </section>
      <section id='department-goals' className={styles['department-goals']}>
        <FontAwesomeIcon icon='bullseye' className={styles['bg-icon']} />
        <TitleSection title={t('goals')} />
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <AnimatedContainer
                animation='bounceInRight'
                extraCssClasses='h-100'
              >
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: isAr
                      ? Array.isArray(departmentDetails[0].goalsAr)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].goalsAr,
                          })
                        : `<p>${departmentDetails[0].goalsAr}</p>`
                      : Array.isArray(departmentDetails[0].goalsEn)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].goalsEn,
                          })
                        : `<p>${departmentDetails[0].goalsEn}</p>`,
                  }}
                ></div>
              </AnimatedContainer>
            </div>
          </div>
        </div>
      </section>
      <section
        id='department-short-term-plan'
        className={styles['department-short-plan']}
      >
        <FontAwesomeIcon icon='hourglass-half' className={styles['bg-icon']} />
        <TitleSection title={t('shortTermPlan')} />
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <AnimatedContainer
                animation='bounceInLeft'
                extraCssClasses='h-100'
              >
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: isAr
                      ? Array.isArray(departmentDetails[0].shortTermPlanAr)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].shortTermPlanAr,
                          })
                        : `<p>${departmentDetails[0].shortTermPlanAr}</p>`
                      : Array.isArray(departmentDetails[0].shortTermPlanEn)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].shortTermPlanEn,
                          })
                        : `<p>${departmentDetails[0].shortTermPlanEn}</p>`,
                  }}
                ></div>
              </AnimatedContainer>
            </div>
          </div>
        </div>
      </section>
      <section
        id='department-long-term-plan'
        className={styles['department-long-plan']}
      >
        <FontAwesomeIcon icon='business-time' className={styles['bg-icon']} />
        <TitleSection title={t('longTermPlan')} />
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <AnimatedContainer animation='bounceInUp' extraCssClasses='h-100'>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: isAr
                      ? Array.isArray(departmentDetails[0].longTermPlanAr)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].longTermPlanAr,
                          })
                        : `<p>${departmentDetails[0].longTermPlanAr}</p>`
                      : Array.isArray(departmentDetails[0].longTermPlanEn)
                        ? blockContentToHtml({
                            blocks: departmentDetails[0].longTermPlanEn,
                          })
                        : `<p>${departmentDetails[0].longTermPlanEn}</p>`,
                  }}
                ></div>
              </AnimatedContainer>
            </div>
          </div>
        </div>
      </section>
    </article>
  ) : (
    <Fragment />
  )
}

export default Content
